/** Voegt klassenamen samen en laat lege waarden weg. */
export const cx = (...parts: Array<string | false | null | undefined>): string =>
  parts.filter(Boolean).join(" ");
